import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import PowerSplitCalculator from '../components/tools/PowerSplitCalculator';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Planetary Power-Split (eCVT) Calculator | Powertrain Tools | AUTOXIUM';
const PAGE_DESCRIPTION = 'Learn how a power-split hybrid eCVT works: planetary speeds and torques, MG1/MG2 and battery power flows, lever diagram and driving modes.';

const PowerSplitCalculatorPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="power-split-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities / Powertrain Tools"
        title="Planetary Power-Split (eCVT) Calculator"
        description="See how the planetary gear set at the heart of a power-split hybrid works: engine, MG1 and MG2 speeds, torques and power flows, the lever diagram, and every driving mode from EV drive to regenerative braking."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="power-split-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <PowerSplitCalculator />
          <ToolGuideCta guidePath="/tools/powertrain/power-split-calculator/guide" toolName="Planetary Power-Split (eCVT) Calculator" />
        </div>
      </section>
    </div>
  );
};

export default PowerSplitCalculatorPage;
